// extracted by mini-css-extract-plugin
module.exports = {"root":"AddTileButton_root__2vqFl","rootSmall":"AddTileButton_rootSmall__3LfGP"};